module.exports = __webpack_public_path__ + "90d250ad24334ae4164d6d8c32e6f2ac.svg";